/*
 * @author: SkyBlue
 * @LastEditors: SkyBlue
 * @Date: 2020-09-25 09:38:05
 * @LastEditTime: 2020-10-09 10:57:20
 * @Gitee: https://gitee.com/skybluefeet
 * @Github: https://github.com/SkyBlueFeet
 */
// @ts-nocheck
import {
  Viewer,
  ScreenSpaceEventType,
  ScreenSpaceEventHandler,
  Entity,
  Cartesian2
} from 'cesium'

function uniqueId() {
  let _val = "";
  do {
    _val = Math.random().toString(36).slice(-8);
  } while (_val.length < 8);
  return _val;
}

export default class Subscriber {
  constructor(viewer, element) {
    this._viewer = viewer;
    this._handler = new ScreenSpaceEventHandler(element || this._viewer.canvas);
    this._isDestroy = false;
    this._eventCollection = Object.create(null);
    this._externalEventCollection = Object.create({});
    this._eventTypeList = [
      'LEFT_DOWN',
      'LEFT_UP',
      'LEFT_CLICK',
      'LEFT_DOUBLE_CLICK',
      'RIGHT_DOWN',
      'RIGHT_UP',
      'RIGHT_CLICK',
      'MIDDLE_DOWN',
      'MIDDLE_UP',
      'MIDDLE_CLICK',
      'MOUSE_MOVE',
      'WHEEL',
      'PINCH_START',
      'PINCH_MOVE',
      'PINCH_END'
    ];
    this._initListener();
  }

  get isDestroy() {
    return this._isDestroy;
  }

  _initListener() {
    this._eventTypeList.forEach(type => {
      this._eventCollection[type] = new Map();
      this._externalEventCollection[type] = new Map();
    });
  }

  _eventRegister(eventType) {
    if (this._isDestroy) return;
    const eventCollection = this._eventCollection[eventType];
    const externalEventCollection = this._externalEventCollection[eventType];
    this._handler.setInputAction(movement => {
      if (externalEventCollection.size > 0) {
        const iterator = externalEventCollection.values();
        let val = iterator.next();
        while (!val.done) {
          val.value(movement);
          val = iterator.next();
        }
      }

      if (this._isDestroy) return;

      if (movement.position || movement.endPosition) {
        let entity;
        if (eventType === 'MOUSE_MOVE') {
          entity = this._viewer.scene.pick(movement.endPosition)?.id;
        } else {
          entity = this._viewer.scene.pick(movement.position)?.id;
        }
        if (
          entity &&
          eventCollection.has(entity.id) &&
          typeof eventCollection.get(entity.id) === 'function'
        ) {
          eventCollection.get(entity.id)(movement, entity);
        }
      }
    }, ScreenSpaceEventType[eventType]);
  }

  add(substances, callback, eventType) {
    if (this._isDestroy) return;
    if (
      this._eventCollection[eventType].size === 0 &&
      this._externalEventCollection[eventType].size === 0
    ) this._eventRegister(eventType);

    substances = Array.isArray(substances) ? substances : [substances];
    for (const substance of substances) {
      this._eventCollection[eventType].set(substance.id, callback);
    }
  }

  addExternal(callback, eventType) {
    if (this._isDestroy) return;
    if (
      this._eventCollection[eventType].size === 0 &&
      this._externalEventCollection[eventType].size === 0
    ) this._eventRegister(eventType);

    const eId = uniqueId();
    this._externalEventCollection[eventType].set(eId, callback);
    return eId;
  }

  remove(substances, eventType) {
    if (this._isDestroy) return;
    substances = Array.isArray(substances) ? substances : [substances];
    for (const substance of substances) {
      if (this._eventCollection[eventType].has(substance.id)) {
        this._eventCollection[eventType].delete(substance.id);
      }
    }
  }

  removeExternal(ids, eventType) {
    if (this._isDestroy) return;
    ids = Array.isArray(ids) ? ids : [ids];
    for (const id of ids) {
      const type = eventType || this._searchExternal(id);
      if (this._externalEventCollection[type]?.has(id)) {
        this._externalEventCollection[type].delete(id);
      }
    }
  }

  _searchExternal(id) {
    if (this._isDestroy) return;
    const types = Object.keys(this._externalEventCollection);
    for (const type of types) {
      const events = this._externalEventCollection[type];
      if (events.has(id)) return type;
    }
    return undefined;
  }

  removeNative(viewer, eventType) {
    viewer.screenSpaceEventHandler.removeInputAction(
      this.convertCesiumEventType(eventType)
    );
  }

  convertCesiumEventType(subscriberEventType) {
    return ScreenSpaceEventType[subscriberEventType];
  }

  destroy() {
    this._isDestroy = true;
    this._externalEventCollection = undefined;
    this._eventCollection = undefined;
    this._viewer = undefined;
    this._handler.destroy();

    this.add = undefined;
    this.addExternal = undefined;
    this.remove = undefined;
    this.removeExternal = undefined;
    this.destroy = undefined;
  }
}